import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  class: "w100 llgreyBg",
  style: {"height":"40px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "w100 pad20" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header_title fs20 fw600" }, "外部通知設定"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs14 mt20" }, " 企業に紐づく調整ページに更新があった場合に通知します。それぞれのユーザーに紐づく通知は、「設定」 > 「外部通知」から行うことができます。 ")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "w100 mb20" }
const _hoisted_13 = { class: "fl w30 pad10" }
const _hoisted_14 = { class: "fw600 pad10" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", {
  class: "mt10 pad10",
  style: {}
}, "ページ遷移時のPV、確定時のPVを測定できます。", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = {
  class: "fl w60",
  style: {"margin-top":"20px"}
}
const _hoisted_19 = {
  key: 0,
  class: "fl mt20",
  style: {"width":"520px"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "w100 pad20" }
const _hoisted_25 = { class: "header_title fs20 fw600" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt12" }, "連携ログ", -1)
const _hoisted_27 = { class: "fs14 ml20 fl" }
const _hoisted_28 = {
  key: 0,
  class: "fs14 ml20 fl mt17"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_30 = { class: "centered pageNation" }
const _hoisted_31 = { class: "fl ml20" }
const _hoisted_32 = { class: "fl ml20" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = {
  key: 0,
  class: ""
}
const _hoisted_35 = { key: 1 }
const _hoisted_36 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "連携ログがありません。", -1)
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 2,
  class: "w100 pad10"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "w20 fl" }
const _hoisted_42 = { class: "arial fs16" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_44 = { class: "fs11" }
const _hoisted_45 = { class: "w20 fl" }
const _hoisted_46 = { class: "fs16" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "w20 fl" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_51 = {
  key: 0,
  class: "w100 pad10 rad10"
}
const _hoisted_52 = { class: "w100" }
const _hoisted_53 = { style: {"white-space":"pre-wrap","word-break":"break-all"} }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_AccountHeader = _resolveComponent("AccountHeader")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_CustomNotificationContent = _resolveComponent("CustomNotificationContent")!
  const _component_ZapierNotificationContent = _resolveComponent("ZapierNotificationContent")!
  const _component_WaaqApiKeysContent = _resolveComponent("WaaqApiKeysContent")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_OptionModal = _resolveComponent("OptionModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `account` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createVNode(_component_AccountHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ml20 ${_ctx.selectedCategory == `settings` ? `fw600 selected` : ``}`),
                  style: {"width":"120px"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectCategory(`settings`)))
                }, " 設定 ", 2),
                _createElementVNode("div", {
                  class: _normalizeClass(`fs12 mt2 fl pointer pad10 ${_ctx.selectedCategory == `integration_logs` ? `fw600 selected` : ``}`),
                  style: {"width":"140px"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCategory(`integration_logs`)))
                }, " 連携ログ ", 2),
                _hoisted_6
              ]),
              _hoisted_7,
              (_ctx.selectedCategory == `settings`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h5", _hoisted_14, [
                          _createElementVNode("img", {
                            src: _ctx.$getAssetImageUrl(`/assets/logo/google_analytics.png`),
                            width: "26",
                            height: "26",
                            class: "pointer fl mr10",
                            style: {"margin-top":"-8px"}
                          }, null, 8, _hoisted_15),
                          _createTextVNode(" Google Analytics設定 ")
                        ]),
                        _hoisted_16,
                        _hoisted_17
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (_ctx.currentUg && _ctx.currentUg.user_group_setting)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createVNode(_component_MdTextfieldTag, {
                                fieldStyle: "min-width:280px;max-width:280px;",
                                style: {"height":"56px","min-width":"280px","max-width":"280px"},
                                class: "fl fs16 mr20",
                                type: `AstagName`,
                                placeholder: `UA/G-○○○○○○`,
                                value: _ctx.currentUg.user_group_setting.google_analytics_id,
                                onInputValue: _ctx.inputGAId,
                                onClickTextfield: _ctx.clickGAId
                              }, null, 8, ["value", "onInputValue", "onClickTextfield"]),
                              (_ctx.canUseGA)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "submit",
                                    class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                    style: {"height":"50px"},
                                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveGAId(false)))
                                  }, _toDisplayString(_ctx.currentUg.google_analytics_id ? `更新` : `登録`), 1))
                                : _createCommentVNode("", true),
                              (_ctx.Util.isPresent(_ctx.currentUg.google_analytics_id))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 1,
                                    class: "fl pointer fs14 mt30 alertRed underline mr20",
                                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deleteGAId && _ctx.deleteGAId(...args)))
                                  }, " 削除 "))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_20
                      ]),
                      _hoisted_21
                    ]),
                    _hoisted_22,
                    _createVNode(_component_CustomNotificationContent, {
                      noti: _ctx.slackDic,
                      availableEvents: _ctx.availableEvents,
                      provider: `slack`,
                      scope: `user_group`,
                      onUpdateNotification: _ctx.updateNotification
                    }, null, 8, ["noti", "availableEvents", "onUpdateNotification"]),
                    _createVNode(_component_CustomNotificationContent, {
                      noti: _ctx.workflowsTeamsDic,
                      availableEvents: _ctx.availableEvents,
                      provider: `workflows_teams`,
                      scope: `user_group`,
                      onUpdateNotification: _ctx.updateNotification
                    }, null, 8, ["noti", "availableEvents", "onUpdateNotification"]),
                    _createVNode(_component_CustomNotificationContent, {
                      noti: _ctx.teamsDic,
                      availableEvents: _ctx.availableEvents,
                      provider: `teams`,
                      scope: `user_group`,
                      onUpdateNotification: _ctx.updateNotification
                    }, null, 8, ["noti", "availableEvents", "onUpdateNotification"]),
                    _createVNode(_component_CustomNotificationContent, {
                      noti: _ctx.webhookDic,
                      availableEvents: _ctx.availableEvents,
                      provider: `webhook`,
                      scope: `user_group`,
                      onUpdateNotification: _ctx.updateNotification
                    }, null, 8, ["noti", "availableEvents", "onUpdateNotification"]),
                    _createVNode(_component_ZapierNotificationContent, {
                      noti: _ctx.zapierDic,
                      scope: `user_group`,
                      onUpdateNotification: _ctx.updateNotification,
                      showOptionModal: _ctx.showOptionModal
                    }, null, 8, ["noti", "onUpdateNotification", "showOptionModal"]),
                    _createVNode(_component_WaaqApiKeysContent, {
                      scope: `user_group`,
                      showOptionModal: _ctx.showOptionModal
                    }, null, 8, ["showOptionModal"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedCategory == `integration_logs`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_SelectTag, {
                            name: "integration_log_type",
                            id: "integration_log_type",
                            class: "fl fs14 roundForm noBorder",
                            style: {"min-width":"30px","height":"50px"},
                            options: _ctx.SelectUtil.integrationLogTypes.map(type => type.name),
                            defaultOption: _ctx.currentIntegrationLogType,
                            onSelectValue: _ctx.selectIntegrationLogType
                          }, null, 8, ["options", "defaultOption", "onSelectValue"])
                        ]),
                        (_ctx.currentPage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.currentPage) + "ページ", 1))
                          : _createCommentVNode("", true),
                        _hoisted_29
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        (_ctx.currentPage > 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.getPrevIntegrationLogs && _ctx.getPrevIntegrationLogs(...args)))
                            }, " < 前へ "))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        (_ctx.currentPage < _ctx.totalPages)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getNextIntegrationLogs && _ctx.getNextIntegrationLogs(...args)))
                            }, " 次へ > "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _hoisted_33,
                    (!_ctx.integrationLogs)
                      ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
                          _createVNode(_component_RoomsLoader)
                        ]))
                      : (_ctx.integrationLogs.length == 0)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                              _hoisted_37,
                              _createElementVNode("img", {
                                src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                width: "40",
                                height: "40"
                              }, null, 8, _hoisted_38)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.integrationLogs, (log, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "",
                                key: index
                              }, [
                                _createElementVNode("div", {
                                  class: "w100 pad10 hoverLgreyBg rad10",
                                  onClick: ($event: any) => (_ctx.showIntegrationLog(log))
                                }, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.Util.getTimeFullFormatFromSeconds(log.created_at, "yyyy/MM/dd HH:mm:ss")), 1),
                                    _hoisted_43,
                                    _createElementVNode("span", _hoisted_44, _toDisplayString(log.id), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("span", _hoisted_46, _toDisplayString(log.parent_room_public_id), 1),
                                    _hoisted_47,
                                    _createElementVNode("span", {
                                      class: "fs11 underline pointer",
                                      onClick: ($event: any) => (_ctx.searchRoom(log.parent_room_public_id))
                                    }, "調整ページへ", 8, _hoisted_48)
                                  ]),
                                  _createElementVNode("div", _hoisted_49, _toDisplayString(log.event_name), 1),
                                  _hoisted_50
                                ], 8, _hoisted_40),
                                (log.options && _ctx.currentLog?.id == log.id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                      _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("pre", _hoisted_53, _toDisplayString(typeof log.options === "string"
                                                ? JSON.stringify(JSON.parse(log.options), null, 2)
                                                : JSON.stringify(log.options, null, 2)), 1)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_54
    ]),
    _createVNode(_component_OptionModal, {
      ref: "OptionModal",
      eventName: _ctx.optionEventName,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel
    }, null, 8, ["eventName", "onClickOK", "onClickCancel"])
  ]))
}